import { SpyneTrait, ViewStream } from "spyne";
import { CodePlaygroundContainer } from "components/code-playground/code-playground-container";
import { PageDocsItemBlockExternalCodesandbox } from "components/pages/page-docs-item-block-external-codesandbox";
import { PageDocsItemBlockExternalStackblitz } from "components/pages/page-docs-item-block-external-stackblitz";
import { PageDocsItemBlockExternalIframe } from "components/pages/page-docs-item-block-external-iframe";

import { PageHomePluginSection } from "components/pages/page-home-plugin-section";
import { PageHomeSolutionsSection } from "components/pages/page-home-solutions-section";

import DefaultImg from "imgs/pexels-photo-432016.jpeg";
import ImgTest1 from "imgs/sonar-development-workflow.png";
import ImgStarterApp from "imgs/spyne-webpack-starter-app.png";
import ImgSpyneCli from "imgs/spyne-cli.png";
import ImgSpyneConsole from "imgs/spyne-console.png";
import ImgDCIChart from "imgs/dci-chart.png";
import ImgGettingStartedVid from "imgs/getting-started-vid.jpg";
import ImgYoutubePoster1 from "imgs/youtube-comp-poster.png";
import ImgSpyneVennDiagram from "imgs/spyne-structure-venn-circles-3.png";
import ImgVBL_List from "imgs/vbl-list.png";
import ImgVBL_Structure from "imgs/vbl-structure.png";
import ImgBehaviorStream from "imgs/behavior-stream-v1.png";


import ImgRouteChannelLocMap from "imgs/route-channel-loc-map.png";
import ImgVBLTriptych from "imgs/vbl-class-triptych.png";
import ImgChannelBehaviorStream from "imgs/channels-behavior-stream.png";
import ImgVBLArchContent from "imgs/vbl-architecture-content.png";


//import routeConfigIframe from 'iframes/route-config-tool/index.html';
import SvgGears from "svgs/gears.svg";
import SvgSypneStructure from "svgs/spyne-structure-all.svg";
import SvgSpyneAppStructure from "svgs/spyne-app-structure.svg";
import SvgDCIChart from "svgs/dci-chart.svg";
import SvgVenDiagram from "svgs/spyne-structure-venn-v1.svg";
import SvgChannelEvtStream from "svgs/channel-event-stream.svg";

import ExternalsVideoTmpl from "components/pages/templates/page-items/page-item-block-external-content-video.tmpl.html";

export class PageDocsItemsExternalTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "pageDocsExternals$";

    super(context, traitPrefix);
  }

  static pageDocsExternals$HelloWorld() {
    return "Hello World";
  }

  static pageDocsExternals$AddExternalItem(data = this.props.data) {
    const { externalType } = data;
    const { pageId } = this.props;
    const defaultFn = () =>
      console.warn(`No Method for External Type ${externalType}`);

    const externalTypesMethodHash = {
      codeBlock: this.pageDocsExternals$AddCodeBlock.bind(this),
      codeSandbox: this.pageDocsExternals$AddCodeSandbox.bind(this),
      stackblitz: this.pageDocsExternals$AddStackblitz.bind(this),
      image: this.pageDocsExternals$AddImage.bind(this),
      iframe: this.pageDocsExternals$AddIframe.bind(this),
      youtube: this.pageDocsExternals$AddYoutube.bind(this),
      video: this.pageDocsExternals$AddVideo.bind(this),
      svg: this.pageDocsExternals$AddSvg.bind(this),
      custom: this.pageDocsExternals$AddCustomSection.bind(this),
    };

    const fn = externalTypesMethodHash[externalType] || defaultFn;

    return fn(data);
  }

  static pageDocsExternals$AddVideo(data) {
    const { externalId } = data;
    const defaultImg = DefaultImg;

    //const serverLoc = "https://assetscontainer.com/temp/spyne-docs-rewrite/videos/";
    const serverLoc = "http://localhost/";
    const videoURL = `${serverLoc}${externalId}`;

    this.appendView(
      new ViewStream({
        data: { videoURL },
        template: ExternalsVideoTmpl,
      }),
      ".external-content-container",
    );
  }

  static pageDocsExternals$AddImage(data) {
    const { externalId } = data;
    const defaultImg = DefaultImg;

    const imgHash = {
      test1: ImgTest1,
      starterApp: ImgStarterApp,
      spyneCli: ImgSpyneCli,
      spyneConsole: ImgSpyneConsole,
      spyneVennDiagram: ImgSpyneVennDiagram,
      dciChart: ImgDCIChart,
      vblList : ImgVBL_List,
      vblStructure: ImgVBL_Structure,
      gettingStarted: ImgGettingStartedVid,
      youtubePoster1: ImgYoutubePoster1,
      behaviorStream: ImgBehaviorStream,
      routeChannelLocMap: ImgRouteChannelLocMap,
      vblTriptych: ImgVBLTriptych,
      channelBehaviorStream: ImgChannelBehaviorStream,
      vblArchContent: ImgVBLArchContent
    };


    const imgSrc = imgHash[externalId] || defaultImg;

    this.appendView(
      new ViewStream({
        tagName: "img",
        src: imgSrc,
      }),
      ".external-content-container",
    );
  }

  static pageDocsExternals$AddYoutube(data = { externalId: "" }) {
    /*
    <iframe width="560" height="315"
            src="https://www.youtube.com/embed/rfML_fHYaZ4?si=6-d86TDnaO8sqgZd"
            title="YouTube video player" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen></iframe>
    */

    //console.log('vid id is ',data);

    const props = {
      template: `<iframe width="100%" height="215"
            src="https://www.youtube.com/embed/${data.externalId}",
            title="YouTube video player" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen></iframe>`,
    };

    this.appendView(new ViewStream(props), ".external-content-container");
  }

  static pageDocsExternals$AddIframe(data) {
    const { externalId } = data;
    const defaultImg = DefaultImg;

    const imgHash = {
      test1: ImgTest1,
      spyneCli: ImgSpyneCli,
      spyneConsole: ImgSpyneConsole,
    };

    const iframeHash = {
      "route-config-tool": `${IFRAMES_PATH}${externalId}/index.html`,
    };

    const src = iframeHash[externalId] || defaultImg;

    this.appendView(
      new PageDocsItemBlockExternalIframe({ data: { src } }),
      ".external-content-container",
    );

    /*    this.appendView(new ViewStream({
      tagName: 'iframe',
      src: iframeSrc,
    }), ".external-content-container")*/
  }

  static pageDocsExternals$AddSvg(data) {
    const { externalId } = data;
    const defaultSvg = SvgGears;

    const svgHash = {
      spyneStructure: SvgSypneStructure,
      spyneAppStructure: SvgSpyneAppStructure,
      dciChart: SvgDCIChart,
      spyneVennDiagram: SvgVenDiagram,
      channelEventStream: SvgChannelEvtStream,
    };

    const template = svgHash[externalId] || defaultSvg;

    //console.log("SVGFILE IS ",{externalId, data, SvgVenDiagram}, svgHash[externalId])

    this.appendView(
      new ViewStream({
        template: template,
      }),
      ".external-content-container",
    );

    // this.props.el$(".external-content-container").el.appendChild(template);
  }

  static pageDocsExternals$AddCustomSection(data) {
    const { externalId } = data;
    const defaultSvg = SvgGears;

    const customSectionHash = {
      homePlugins: PageHomePluginSection,
      homeSolutions: PageHomeSolutionsSection,
    };

    const viewStreamSection = customSectionHash[externalId] || defaultSvg;

    this.appendView(
      new viewStreamSection({ data }),
      ".external-content-container",
    );

    // this.props.el$(".external-content-container").el.appendChild(template);
  }

  static pageDocsExternals$AddStackblitz(data = {}) {
    this.appendView(
      new PageDocsItemBlockExternalStackblitz({ data }),
      ".external-content-container",
    );
  }

  static pageDocsExternals$AddCodeSandbox(data = {}) {
    const { externalId } = data;

    const defaultFn = () => {
      console.warn("NO SRC FOR CODESANDBOX ", { externalId, title });
      return false;
    };
    const codeSandboxHash = {
      reactDev: {
        title: "react dev",
        src: "https://codesandbox.io/embed/q2z497?view=Editor+%2B+Preview",
      },
      toh: {
        title: "Tour of Heroes",
        src: "https://codesandbox.io/embed/y5gxc?view=Editor+%2B+Preview",
      },
    };

    const props = codeSandboxHash[externalId] || defaultFn();

    if (props !== false) {
      this.appendView(
        new PageDocsItemBlockExternalCodesandbox(props),
        ".external-content-container",
      );
    }
  }

  static pageDocsExternals$AddCodeBlock(data = {}) {
    const { pageId } = this.props;

    const codeBlockDataSection = pageId === "reference" ? "reference" : "types";

    const { externalId } = data;
    const codeBlockId = externalId;
    this.appendView(
      new CodePlaygroundContainer({
        codeBlockId,
        pageId,
        codeBlockDataSection,
      }),
      ".external-content-container",
    );
  }
}
